module.exports = __webpack_public_path__ + "static/media/dummyProfile.55f97778.png";